import { jsx, jsxs } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material/utils";
const ColorPickerIcon = createSvgIcon(/* @__PURE__ */ jsx("svg", { width: "32", height: "32", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxs("g", { id: "prefix__icons/color_picker", children: [
  /* @__PURE__ */ jsx("circle", { id: "prefix__Ellipse 2851", cx: 16, cy: 16, r: 12.75, strokeWidth: 2.5 }),
  /* @__PURE__ */ jsx("circle", { id: "prefix__Ellipse 2852", cx: 16, cy: 16, r: 9 })
] }) }), "ColorPickerIcon");
export {
  ColorPickerIcon
};
